/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ExamRevisionQuestionQuestionid202,
  DeleteApiV1ExamRevisionQuestionQuestionid400,
  DeleteApiV1ExamRevisionQuestionQuestionid401,
  DeleteApiV1ExamRevisionQuestionQuestionid500,
  DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
  DeleteApiV1ExamRevisionQuestionQuestionidPathParams,
} from "../../types/examRevisionController/DeleteApiV1ExamRevisionQuestionQuestionid.ts";

export const deleteApiV1ExamRevisionQuestionQuestionidPathParamsSchema =
  z.object({
    questionId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ExamRevisionQuestionQuestionidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ExamRevisionQuestionQuestionid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionQuestionQuestionid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1ExamRevisionQuestionQuestionid400Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionQuestionQuestionid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ExamRevisionQuestionQuestionid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionQuestionQuestionid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ExamRevisionQuestionQuestionid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamRevisionQuestionQuestionid500>;

export const deleteApiV1ExamRevisionQuestionQuestionidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ExamRevisionQuestionQuestionid202Schema,
  ) as unknown as ToZod<DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse>;
